// Top navigation bar — fixed across all pages.
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Trophy, Newspaper } from "lucide-react";
import LanguageSwitcher from "../LanguageSwitcher";

const Navigation = () => {
  const { t } = useTranslation();
  return (
    <nav className="fixed top-0 left-0 right-0 z-50 bg-slate-950/95 backdrop-blur-md border-b border-slate-800">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-16">
          <Link to="/" className="flex items-center gap-2">
            <Trophy className="w-6 h-6 text-green-400" />
            <span className="text-xl font-bold text-white" style={{ fontFamily: "'Barlow Condensed', sans-serif" }}>
              SPORTSGURU247
            </span>
          </Link>
          <div className="hidden md:flex items-center gap-5">
            <Link to="/" className="text-slate-300 hover:text-green-400 transition-colors text-sm">{t("nav.home")}</Link>
            <Link to="/best-betting-sites" data-testid="nav-betting-sites" className="text-slate-300 hover:text-emerald-300 transition-colors text-sm">Betting Sites</Link>
            <Link to="/casino-reviews" data-testid="nav-casinos" className="text-slate-300 hover:text-purple-300 transition-colors text-sm">Casinos</Link>
            <Link to="/blog" data-testid="nav-blog" className="text-slate-300 hover:text-green-400 transition-colors text-sm">{t("nav.blog")}</Link>
            <Link to="/news" data-testid="nav-news" className="text-emerald-300 hover:text-emerald-200 transition-colors text-sm font-semibold flex items-center gap-1">
              <Newspaper className="w-4 h-4" />
              News
            </Link>
            <Link to="/advertise" data-testid="nav-advertise" className="text-amber-300 hover:text-amber-200 transition-colors text-sm font-semibold">Advertise</Link>
            <LanguageSwitcher />
          </div>
          <div className="md:hidden flex items-center gap-2">
            <LanguageSwitcher />
          </div>
        </div>
      </div>
    </nav>
  );
};

export default Navigation;
